import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import BindSystems from '../../img/agenda/BindSystems.png'
import Chaurasia from '../../img/agenda/Chaurasia.png'
import Murzabulatov from '../../img/agenda/Murzabulatov.png'
import Nash from '../../img/agenda/Nash.png'
import Rabobank from '../../img/agenda/Rabobank.png'
import sonar from '../../img/agenda/sonar.png'

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    time: '10:10',
                    day: 'Tuesday, May 09',
                    photo: Nash,
                    name: 'Phil Nash',
                    position: 'Developer Advocate',
                    ln: 'https://www.linkedin.com/in/philnash/',
                    tw: 'https://twitter.com/philnash',
                    github: 'https://github.com/philnash',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=The+top+5+TypeScript+issues+in+all+our+codebases&dates=20230509T101000Z/20230509T104000Z&details=We+all+try+to+write+the+best+code+we+can,+but+sometimes+things+slip+through+the+cracks.+With+a+look+at+the+data+from+scans+of+thousands+of+projects,+we+can+tell+what+the+most+common+issues+are+in+the+codebases+of+all+TypeScript+developers.In+this+talk+we%E2%80%99ll+take+a+look+at+those+top+issues+that+plague+TypeScript+projects+around+the+world,+we%27ll+see+why+they+are+issues,+and+finally+how+to+spot+and+avoid+those+common+errors,+issues+or+anti+patterns.+By+the+end+of+the+talk+you%E2%80%99ll+feel+more+confident+in+your+codebase+and+maybe+have+a+few+things+to+fix.&location=online',
                    logo: sonar,
                    title: 'The top 5 TypeScript issues in all our codebases',
                    abstract: `We all try to write the best code we can, but sometimes things slip through the cracks. With a look at the data from scans of thousands of projects, we can tell what the most common issues are in the codebases of all TypeScript developers.

                    In this talk we’ll take a look at those top issues that plague TypeScript projects around the world, we'll see why they are issues, and finally how to spot and avoid those common errors, issues or anti patterns. By the end of the talk you’ll feel more confident in your codebase and maybe have a few things to fix.`,
                },
                {
                    time: '10:40',
                    day: 'Tuesday, May 09',
                    photo: Chaurasia,
                    name: 'Deepa Chaurasia',
                    position: 'Frontend Engineer',
                    ln: 'https://www.linkedin.com/in/deepa-chaurasia-notes',
                    tw: 'https://twitter.com/deepachaurasia1',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=Underrated+Features+of+Typescript&dates=20230509T104000Z/20230509T111000Z&details=I+am+going+to+be+covering+1.Generic+function+signatures+2.Type+Guards+3.Interfaces+4.+Enums+5.+Advances+Types+6.Enums&location=online',
                    logo: BindSystems,
                    title: 'Underrated Features of Typescript',
                    abstract: `I am going to be covering 1.Generic function signatures 2.Type Guards 3.Interfaces 4. Enums 5. Advances Types 6.Enums`,
                },
                {
                    time: '11:10',
                    day: 'Tuesday, May 09',
                    photo: Murzabulatov,
                    name: 'Arman Murzabulatov',
                    position: 'Senior Software Engineer',
                    ln: 'https://www.linkedin.com/in/murzabulatov/',
                    tw: 'https://twitter.com/kz_arman',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=Advanced+TypeScript+Techniques+for+Clean,+Concise+Code&dates=20230509T111000Z/20230509T114000Z&details=Showcasing+some+of+the+more+advanced+features+of+TypeScript,+such+as+generics,+decorators,+and+conditional+types+(etc.),+and+how+they+can+be+used+to+write+cleaner,+more+concise+code.Sharing+insights+and+best+practices+of+my+journey+of+utilizing+TypeScript+at+its+full+potential.+Including+challenges,+best+practices,+and+real-world+examples.+&location=online',
                    logo: Rabobank,
                    title: 'Advanced TypeScript Techniques for Clean, Concise Code',
                    abstract: `Showcasing some of the more advanced features of TypeScript, such as generics, decorators, and conditional types (etc.), and how they can be used to write cleaner, more concise code.
                    Sharing insights and best practices of my journey of utilizing TypeScript at its full potential. Including challenges, best practices, and real-world examples.`,
                },
            ],
        }
    }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h2 className="agenda_title">Agenda</h2>
                    <VideoPresent speakers={this.state.list} />
                    <a className='button agenda_full_btn' href='https://geekle.us/schedule/typescript' target='_blank' rel="noreferrer">SHOW MORE</a>
                </div>
            </div>
        );
    }
};